import { lazy } from 'react'

const ProgramsModule = lazy(async () => {
  const { Programs } = await import(/* webpackChunkName: "programs-routes" */ './')

  return {
    default: Programs
  }
})
const routes = [
  {
    path: '/programs',
    name: 'Programs',
    authenticated: true,
    render(props) {
      return <ProgramsModule {...props} />
    }
  }
]

export { routes }
